export const FINDINGS_BASE = "/v2/findings";
export const FINDINGS_POSTURE = `${FINDINGS_BASE}/posture`;
export const FINDINGS_THREAT_INSIGHTS = `${FINDINGS_BASE}/threat-insights`;

export function isFindingsRoute(pathname) {
  if (!pathname) return false;
  return pathname.startsWith(FINDINGS_BASE);
}

export function isFindingsPostureRoute(pathname) {
  if (!pathname) return false;
  return pathname === FINDINGS_POSTURE || pathname.startsWith(`${FINDINGS_POSTURE}/`);
}

export function isFindingsThreatInsightsRoute(pathname) {
  if (!pathname) return false;
  return (
    pathname === FINDINGS_THREAT_INSIGHTS ||
    pathname.startsWith(`${FINDINGS_THREAT_INSIGHTS}/`)
  );
}
